const transformations = {
    'O&O': 'O&O Account',
    'Non-O&O': 'Non-O&O Account',
    Player: 'Player Account',
    Home: 'Home Broadcast',
    National: 'National Broadcast',
    Other: 'Other Broadcast',
};

const transformAccOwnerships = name => {
    return transformations[name] ? transformations[name] : name;
};

export default transformAccOwnerships;
